import { Type } from '@angular/core';

import { ISnHasHostElement } from '../interfaces';
import { SnColorPalette } from '../types';

export interface ISnCanColor {
  color: SnColorPalette;
}

export interface ISnMixinColorOptions {
  defaultColor?: SnColorPalette;
  prefix?: string;
}

export function mixinColor<T extends Type<ISnHasHostElement>>(
  base: T,
  options?: ISnMixinColorOptions,
): Type<ISnCanColor> & T {
  return class extends base {
    private _color: SnColorPalette;

    constructor(...args: any[]) {
      super(...args);

      if (options) {
        this.color = options.defaultColor;
      }
    }

    get color(): SnColorPalette {
      return this._color;
    }
    set color(value: SnColorPalette) {
      if (this._color !== value) {
        const prefix = options && options.prefix ? `sn-${options.prefix}--` : 'sn-';

        if (this._color) {
          this.hostElement.classList.remove(`${prefix}${this._color}`);
        }

        this._color = value;

        if (this._color) {
          this.hostElement.classList.add(`${prefix}${this._color}`);
        }
      }
    }
  };
}
